const cleanLabel = (value) => String(value || '').replace(/\s+/g, ' ').trim();

export const buildTableQrLabel = (table = {}) => {
  const number = cleanLabel(table.number || table.tableNumber || table.id);
  const name = cleanLabel(table.name || table.tableName).slice(0, 70);
  const primary = number ? `Mesa ${number}` : 'Mesa';
  return name && name.toLocaleLowerCase('pt-BR') !== primary.toLocaleLowerCase('pt-BR')
    ? `${primary} — ${name}`
    : primary;
};

const loadBlobImage = async (blob) => {
  if (typeof createImageBitmap === 'function') return createImageBitmap(blob);
  const objectUrl = URL.createObjectURL(blob);
  try {
    return await new Promise((resolve, reject) => {
      const image = new Image();
      image.onload = () => resolve(image);
      image.onerror = () => reject(new Error('Não foi possível preparar a imagem do QR Code.'));
      image.src = objectUrl;
    });
  } finally {
    URL.revokeObjectURL(objectUrl);
  }
};

export const composeTableQrPng = async (qrBlob, table = {}) => {
  if (!qrBlob) throw new Error('Imagem do QR Code não encontrada.');
  const qrImage = await loadBlobImage(qrBlob);
  const qrWidth = Number(qrImage.width || qrImage.naturalWidth || 960);
  const qrHeight = Number(qrImage.height || qrImage.naturalHeight || 960);
  const headerHeight = Math.max(140, Math.round(qrWidth * 0.16));
  const canvas = document.createElement('canvas');
  canvas.width = qrWidth;
  canvas.height = headerHeight + qrHeight;
  const context = canvas.getContext('2d');
  if (!context) throw new Error('Este navegador não permite preparar o QR Code para impressão.');

  context.fillStyle = '#ffffff';
  context.fillRect(0, 0, canvas.width, canvas.height);
  context.fillStyle = '#111827';
  context.textAlign = 'center';
  context.textBaseline = 'middle';
  context.font = `700 ${Math.max(42, Math.round(qrWidth * 0.055))}px Arial, sans-serif`;
  const label = buildTableQrLabel(table);
  const maxTextWidth = qrWidth * 0.88;
  let fontSize = Math.max(42, Math.round(qrWidth * 0.055));
  while (context.measureText(label).width > maxTextWidth && fontSize > 30) {
    fontSize -= 2;
    context.font = `700 ${fontSize}px Arial, sans-serif`;
  }
  context.fillText(label, qrWidth / 2, headerHeight / 2, maxTextWidth);
  context.drawImage(qrImage, 0, headerHeight, qrWidth, qrHeight);
  qrImage.close?.();

  return new Promise((resolve, reject) => {
    canvas.toBlob((blob) => {
      if (blob) resolve(blob);
      else reject(new Error('Não foi possível gerar o PNG identificado da mesa.'));
    }, 'image/png');
  });
};
